import * as React from "react";
import {ITimeFrame, TimeFrame, timeFramesCollection} from "../../../../../../config/time_frames";
import {DateRangePicker} from "./DateRangePicker";
import { SelectField } from "../../../../../Components/Form/SelectField";
import { IForm } from "../../../../../../hooks/use_form_v2";
import { ITransactionsSearchFormOutputData } from "../../../../../../config/search";
import { Form } from "../../../../../Components/Form/Form/Form";

const getTimeFrameByID = (id: TimeFrame): ITimeFrame => {
    return timeFramesCollection[id] as any;
};

interface ITimePeriodFilterProps {
    form: IForm<ITransactionsSearchFormOutputData>;
}

export const TimePeriodFilter = ({form}: ITimePeriodFilterProps) => {
    const { change, register, watch } = form;

    const handleChangeTimePeriod = (value: TimeFrame) => {
        change()({
            timePeriod: value,
            timeRange: getTimeFrameByID(value).getRange(),
        });
    };

    return (
        <>
            <Form.Field
                noWrapper
                type={SelectField}
                {...register(('timePeriod'))}
                onChange={handleChangeTimePeriod}
                options={Object.keys(timeFramesCollection)}
                optionValueGetter={(v: any) => v}
                optionLabelGetter={(v: any) => (timeFramesCollection as any)[v].label}
            />

            <Form.Field
                noWrapper
                type={DateRangePicker}
                {...register('timeRange')}
                conditional={watch('timePeriod') === TimeFrame.CUSTOM}
            />
        </>
    );
};
